export default class FormulaNotFoundError extends Error {
    constructor(formulaIndex: number) {
        super(`Formula "${formulaIndex}" not found`);
    }
}


// WEBPACK FOOTER //
// ./src/Models/pricingRulesInterface/exception/FormulaNotFoundError.ts